import * as Sentry from "@sentry/react"
import "@/lib/i18n.app"
import "@/globals.css"
import { createRoot } from "react-dom/client"
import { createInertiaApp } from "@inertiajs/react"
import { LandingLayout } from "@/layouts/landing-layout"
import type { ReactNode } from "react"
import { ErrorPage } from "@/components/error"

const pages = import.meta.glob("../pages/landing/**/*.tsx", { eager: true }) as Record<
  string,
  { default: React.ComponentType<Record<string, unknown>> & { layout?: (page: ReactNode) => ReactNode } }
>

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/landing/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    const component = page.default
    if (!component.layout) {
      component.layout = (page: ReactNode) => <LandingLayout>{page}</LandingLayout>
    }
    return component
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <Sentry.ErrorBoundary fallback={({ error }) => <ErrorPage error={error} />}>
        <App {...props} />
      </Sentry.ErrorBoundary>
    )
  },
  progress: {
    color: "oklch(0.68 0.15 264)"
  }
})
